<script>
  import Download from "../common/download.svelte";
  import Share from "../common/share.svelte";
  import {
    currentQuote,
    theme,
    isShareOpen,
    isDownloadOpen,
  } from "../../stores/store";

  let urlHostName: string = window.location.origin;

  function updateURL(URL: string) {
    return window.history.pushState({}, "", URL);
  }

  function toggleTheme() {
    switch ($theme) {
      case "dark":
        theme.set("light");
        updateURL(urlHostName + "/?q=" + $currentQuote["_id"] + 1);
        break;
      case "light":
        theme.set("dark");
        updateURL(urlHostName + "/?q=" + $currentQuote["_id"] + 0);
        break;
    }
  }

  function toggleShare() {
    isDownloadOpen.set(false);
    let currentStatus = $isShareOpen ? false : true;
    isShareOpen.set(currentStatus);
  }

  function toggleDownload() {
    isShareOpen.set(false);
    let currentStatus = $isDownloadOpen ? false : true;
    isDownloadOpen.set(currentStatus);
  }
</script>

<div class="navbar-wrapper">
  <div class="navbar">
    <div class="logo">Retale.</div>
    <div>
      {#if $theme === "dark"}
        <button on:click={toggleTheme}>
          <i class="far fa-lightbulb fa-2x" />
        </button>
      {:else}
        <button on:click={toggleTheme}>
          <i class="far fa-lightbulb-on fa-2x" />
        </button>
      {/if}
    </div>
    <div class="options">
      <button on:click={toggleDownload}>
        <i class="far fa-2x fa-arrow-to-bottom" />
      </button>
      <button on:click={toggleShare}>
        <i class="far fa-2x fa-share-alt" />
      </button>
    </div>
  </div>
  <Download />
  <Share />
</div>

<style lang="scss">
  .navbar-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 90vw;
  }
  .navbar {
    display: flex;
    width: 100%;
    flex-direction: row;
    min-height: 15vh;
    align-items: center;
    justify-content: space-between;
    .logo {
      flex-basis: 97px;
      font-size: 1.6em;
      font-weight: bold;
      cursor: default;
    }
    button {
      padding: 20px 15px;
      border: none;
      background: none;
      margin: 0;
      &:hover {
        opacity: 1;
      }
      &:active {
        background: none;
      }
      &:disabled {
        cursor: default;
      }
      i {
        min-width: 25px;
      }
    }
    .options {
      button {
        &:last-child {
          padding: 20px 0 20px 15px;
        }
      }
    }
  }
</style>
